<template>
  <div>
    <Slider
      :banner="
        `https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about.jpg`
      "
    >
      <div class="row align-items-center">
        <div class="col  fontsiyuanmedium">
          <div class="slider-title fontsiyuanmedium">关于天鑫</div>
          <div class="slider-subtitle fontsiyuanregular">
            中国燃气应用行业实力派制造商
          </div>
        </div>
      </div>
    </Slider>
    <div
      class="news-title-group row justify-content-center"
      style="text-align:center"
    >
      <div
        :class="
          `col-lg-1 col-md-2 col-sm-3 col-6 news-title ${
            index == active ? 'active' : ''
          }`
        "
        @click="change(index)"
        v-for="(item, index) in titles"
        v-bind:key="index"
      >
        {{ item }}
      </div>
    </div>
    <b-container>
      <b-row class="justify-content-md-left about-content-1">
        <b-col cols="10" md="2" lgt="2">
          <span class="about-title">精益生产</span></b-col
        >
        <b-col cols="12" md="10" lgt="10">
          <div class="row">
            <div
              class="col-10"
              style="font-size:20px;font-weight:bold;color:#666666"
            >
              从高标准甄选原材料,到先进的生产检测设备<br />
              到先进的生产工艺流程
            </div>
          </div>
          <div class=" row about-content-info">
            <div class="col-10">
              天鑫人把精益生产理念贯穿于管理的方方面面，让软管像仪表一样精密可靠，是天鑫人始终追求的品质和目标。
            </div>
          </div>
          <b-img
            style="margin-top:40px;"
            src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-01.png"
            fluid
            alt="宁波天鑫仪表有限公司"
          ></b-img>

          <div class=" row about-content-info">
            <div class="col-10">
              天鑫人时刻保持一种对行业的敬畏和锐意进取的精神，不断实现材料创新、产品品类的创新，技术的迭代更新和对管理的创新，时时不怠精益生产和追求卓越的脚步。
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-12" >
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-02.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
            <div class="col-md-4 col-sm-12" >
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-03.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-12" >
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-04.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
            <div class="col-md-4 col-sm-12" >
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-05.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-12" >
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-06.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
            <div class="col-md-4 col-sm-12" >
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-07.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
          </div>
          <div
            class="w-100"
            style=" height:10px;width:100%;margin-top:50px;"
          ></div>
        </b-col>
      </b-row>
    </b-container>

    <Footer class="w-100" />
  </div>
</template>

<script>
import Slider from "../components/slider2";
import Footer from "../components/footer";
import Sticky from "sticky-js";
export default {
  components: {
    Slider,
    Footer,
  },
  data() {
    return {
      titles: [
        "天鑫介绍",
        "天鑫文化",
        "发展历程",
        "技术研发",
        "质量管控",
        "精益生产",
        "精英团队",
        "合作伙伴",
        "客户服务",
        "企业荣誉",
      ],
      active: 0,
      newslist: [],
      max: 0,
      value: 0,

      rows: 100,
      perPage: 10,
      currentPage: 1,
    };
  },
  methods: {
    change(index) {
      this.active = index;
      switch (parseInt(index)) {
        case 0:
          this.$router.push('/about?sort=0')
          break;
        case 1:
          this.$router.push('/about?sort=1')
          break;
        case 2:
          this.$router.push('/aboutend?sort=2')
          break;
        case 3:
          this.$router.push('/study?sort=3')
          break;
        case 4:
          this.$router.push('/study?sort=4')
          break;
        case 5:
          this.$router.push('/production?sort=5')
          break;
        case 6:
          this.$router.push('/aboutteam?sort=6')
          break;
        case 7:
          this.$router.push('/aboutteam?sort=7')
          break;
        case 8:
          this.$router.push('/aboutteam?sort=8')
          break;
      }
          const sticky2 = new Sticky(".sticky2");
          sticky2.update();
    },
  },
};
</script>
<style>
.slider-title {
  margin-left: 65px;
  color: #fff;
  font-size: 42px;
  font-weight: bold;
}
.slider-subtitle {
  margin-left: 65px;
  color: #fff;
  font-size: 20px;
  font-weight: 100;
}
.news-title-group {
  border-bottom: 0.5px #bdbdbd88 solid;
}
.news-title {
  padding: 20px 0;
}
.news-title.active {
  color: #c00f31;
  font-weight: bold;
}
.news-list {
  padding-bottom: 100px;
}
.page-item.active .page-link {
  color: #c00f31;
  background-color: #ffffff00;
}
.page-link {
  color: #000;
  border: 0;
}
.page-link:hover {
  color: #c00f31;
}
.pagestyle {
  color: #000;
  padding: 6px 10px;
  border: 0.5px #bdbdbd88 solid;
}
.pagestyle:hover {
  background-color: #00000000;
  color: #c00f31;
}
.page-item:hover {
  background-color: #00000000;
}
.news-pagination {
  margin-top: 100px;
}
.news-item {
  margin-top: 50px;
  cursor: pointer;
}

.news-item:hover {
  -webkit-box-shadow: #00000034 0px 0px 10px;
  -moz-box-shadow: #00000034 0px 0px 10px;
  box-shadow: #00000034 0px 0px 10px;
}
.news-body {
  padding: 10px 30px 20px 30px;
  background-color: #ededed;
}
.product-item-body-head {
  font-size: 12px;
}
.product-item-date {
  font-size: 12px;
  font-weight: 200;
  color: #8a8a8a;
  margin-left: 10px;
}
.product-item-type {
  background-color: #c00f31;
  color: #ffffff;
  padding: 0 5px;
  margin-left: 15px;
}
.news-item-title {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.news-item-info {
  margin-top: 30px;
  font-size: 12px;
  color: #8a8a8a;
}
@media only screen and (max-width: 500px) {
  .slider-title {
    margin-left: 65px;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
  }
  .slider-subtitle {
    margin-left: 65px;
    color: #fff;
    font-size: 10px;
    font-weight: 100;
  }
}
.about-content-1 {
  margin-top: 50px;
  margin-bottom: 50px;
}
.about-title {
  font-size: 25px;
  font-weight: bold;
  border-bottom: 2px #c00f31 solid;
  margin-bottom: 50px;
  white-space: nowrap;
}
.about-content-info {
  color: #666666;
  font-weight: 400;
  font-size: 12px;
}

.about-content-info div {
  margin-top: 20px;
}
.about-content-2 {
  min-height: 260px;
  background: url(https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about/about-bg-01.jpg)
    no-repeat top center scroll;
  background-size: cover;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
}

.about-content-2 img {
  height: 110px;
  margin-top: 40px;
}
.about-img-content {
  background-color: #fff;
  min-height: 220px;
}
.info-title {
  color: #000;
  font-size: 15px;
  font-weight: bold;
}
.b-bg {
  background-color: #ededed;
  text-align: center;
  padding: 50px 0;
  margin-bottom: 30px;
}

.b-bg .slogn {
  font-weight: bold;
}
.b-bg .info {
  font-weight: 200;
}
.about-title-bootom {
  position: absolute;
  bottom: 0;
  left: 0;
}
@media only screen and (max-width: 500px) {
  .about-title-bootom {
    position: relative;
  }
}
</style>
